import React from 'react'

export default () => {
  const [loaded, setLoaded] = React.useState(false);
  const script = React.useRef();
  React.useEffect(() => {
    if (!window.iTransact) {
      script.current = document.createElement('script')
      script.current.type = 'text/javascript'
      script.current.src = 'https://js.itransact.com/itransact.js'
      document.head.appendChild(script.current)
      script.current.onload = e => {
        setLoaded(true)
      }
    }else{
      setLoaded(true)
    }
  }, [])
  return loaded
}



// WEBPACK FOOTER //
// ./src/components/SavedPayments/useItransact.js